import { QUESTION_TYPES } from '@api/instant_survey';

export const getSurveyQuestionCount = (questions = []) =>
  questions.reduce((count, question) => {
    if (question.type === QUESTION_TYPES.SEQUENTIAL_MONADIC.value) {
      return count + (question.subQuestions?.length || 0) * (question.concepts?.length || 0);
    }

    return count + 1;
  }, 0);
